import { useEffect } from "react";
import MobBanner from "../HomePage/Technology/AllBanner/MobBanner";
import MobMain from "./TechnologiesMobPage/MobMain";
import FooterContact from "../FooterContactPage/FooterContact";
import { Helmet } from "react-helmet-async";

const TechMobile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        <title>Mobile Technologies and Frameworks | Quad Theory Ltd</title>
        <meta
          name="description"
          content="Explore mobile technologies and frameworks used by Quad Theory Ltd, including native, cross platform, hybrid, and PWA approaches."
        />
      </Helmet>
      <MobBanner />
      <MobMain />
      {/* form component yeameen */}
      <FooterContact />
    </div>
  );
};

export default TechMobile;
